import { TextBox } from '@superdispatch/ui-lab';
import { InlineBulletItems } from 'shared/ui/InlineBulletItems';
import { PostingPricePerMile } from '../core/postings/PostingPricePerMile';
import { formatLoadDistance, PostingLoadDTO } from '../data/dto/PostingLoadDTO';

interface PostingDistancePriceDetailsProps {
  load: PostingLoadDTO;
}

export function PostingDistancePriceDetails({
  load: { price_per_km, distance_meters },
}: PostingDistancePriceDetailsProps) {
  return (
    <InlineBulletItems space="xxsmall">
      {price_per_km != null && (
        <PostingPricePerMile pricePerKm={price_per_km} />
      )}
      {distance_meters != null && (
        <TextBox color="secondary">
          {formatLoadDistance(distance_meters)}
        </TextBox>
      )}
    </InlineBulletItems>
  );
}
